export default "__VITE_ASSET__Z05mVfqN__"